var riot = require("riot");

riot.tag2('ahv-calculation-basis', '<div class="row" id="ahv-calculation-basis" show="{calculationText}"> <div class="col-lg-12"> <div class="row"> <div class="col-lg-7 offset-lg-1"> <div id="ahv-calculation-basis-referent">(1)</div> {calculationText} </div> </div> <div class="row" show="{lastConveyanceDateRegistered && lastConveyancePurchasePrice}"> <div class="col-lg-7 offset-lg-1"> Siste omsetning for fritt salg: {lastConveyanceDateRegistered} for kr. {lastConveyancePurchasePrice} </div> </div> </div> </div>', '', '', function(opts) {
    require("./CalculationBasisMapper").init(this);
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/calculationBasis/ahv-calculation-basis.tag
 ** module id = 83
 ** module chunks = 0
 **/